<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios de Referências e Contrarreferências") }}
      </h1>

      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios de Referências e Contrarreferências"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>
        <b-dropdown-group
          id="dropdown-group-1"
          header="Relátorios de Referências e Contrarreferências"
        >
          <b-dropdown-item
            :to="'/dashboard/relatorios/referenciamentos/home'"
            :disabled="$route.name == 'relatorios_home_referenciamentos'"
          >
            Todas as Referências e Contrarreferências
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/referenciamentos/graficos'"
            :disabled="$route.name == 'graficos_referenciamentos'"
          >
            Gráficos de Referências e Contrarreferências
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>
    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportsReferenciasContrarReferencias",
  metaInfo() {
    return {
      title: this.$i18n.t("Relatórios de Referências e Contrarreferências"),
    };
  },
  mounted() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>
